/**
 * Module valuation-primitives defines shared valuation enums and their inferred types,
 * including status, calculation method, report type, and rounding strategy.
 *
 * These enums are shared across valuation or order schemas. Object schemas are defined in
 * the corresponding domain modules.
 */
import { z } from 'zod';
export const ValuationStatusSchema = z.enum(['in_review', 'in_progress', 'finalised']);
export const ValuationMethodSchema = z.enum([
    'cost',
    'income',
    'comparison',
    'land_value',
    'custom',
    'leasehold',
    'discounted_cashflow',
    'investment_method',
]);
export const ValuationTypeSchema = z.enum(['einwert', 'external', 'historical']);
export const ReportTypeSchema = z.enum(['short_report', 'extended_report', 'revaluation_report']);
export const ExternalReportTypeSchema = z.enum(['short_report', 'extended_report', 'revaluation_report', 'benchmark_report']);
export const ExternalValuationSubmissionTriggerSchema = z.enum(['draft', 'final']);
export const RoundingStrategySchema = z.enum([
    'no_rounding',
    'default',
    'custom',
    'nearest_100',
    'nearest_500',
    'nearest_1_000',
    'nearest_5_000',
    'nearest_10_000',
    'nearest_50_000',
    'nearest_100_000',
    'nearest_500_000',
    'nearest_1_000_000',
    'nearest_5_000_000',
    'nearest_10_000_000',
]);
